/**
 * Tetromino piece definitions with all rotations and mirror variants
 */
// Define all tetromino rotations
// Normalized so they start at (0,0)
const I_ROTATIONS = [
    // 0° - Horizontal, anchor at left
    { cells: [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 }, { x: 3, y: 0 }], width: 4, height: 1 },
    // 90° - Vertical, anchor at top
    { cells: [{ x: 0, y: 0 }, { x: 0, y: 1 }, { x: 0, y: 2 }, { x: 0, y: 3 }], width: 1, height: 4 },
    // 180° - Horizontal, anchor at right
    { cells: [{ x: 3, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 }], width: 4, height: 1 },
    // 270° - Vertical, anchor at bottom
    { cells: [{ x: 0, y: 3 }, { x: 0, y: 0 }, { x: 0, y: 1 }, { x: 0, y: 2 }], width: 1, height: 4 },
];
const L_ROTATIONS = [
    // 0° - anchor at tip of long arm (top)
    { cells: [{ x: 0, y: 0 }, { x: 0, y: 1 }, { x: 0, y: 2 }, { x: 1, y: 2 }], width: 2, height: 3 },
    // 90° - anchor at tip of long arm (right)
    { cells: [{ x: 2, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 0, y: 1 }], width: 3, height: 2 },
    // 180° - anchor at tip of long arm (bottom)
    { cells: [{ x: 1, y: 2 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 1, y: 1 }], width: 2, height: 3 },
    // 270° - anchor at tip of long arm (left)
    { cells: [{ x: 0, y: 1 }, { x: 1, y: 1 }, { x: 2, y: 1 }, { x: 2, y: 0 }], width: 3, height: 2 },
];
const O_ROTATIONS = [
    // All rotations are the same
    { cells: [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 1 }], width: 2, height: 2 },
];
const S_ROTATIONS = [
    // 0° - Horizontal, anchor at bottom-left
    { cells: [{ x: 0, y: 1 }, { x: 1, y: 0 }, { x: 2, y: 0 }, { x: 1, y: 1 }], width: 3, height: 2 },
    // 90° - Vertical, anchor at top-left
    { cells: [{ x: 0, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 1 }, { x: 1, y: 2 }], width: 2, height: 3 },
    // 180° - Horizontal, anchor at top-right
    { cells: [{ x: 2, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 0 }, { x: 1, y: 1 }], width: 3, height: 2 },
    // 270° - Vertical, anchor at bottom-right
    { cells: [{ x: 1, y: 2 }, { x: 0, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 1 }], width: 2, height: 3 },
];
const T_ROTATIONS = [
    // 0° - bar on top, anchor at bar center (T-junction)
    { cells: [{ x: 1, y: 0 }, { x: 0, y: 0 }, { x: 2, y: 0 }, { x: 1, y: 1 }], width: 3, height: 2 },
    // 90° - bar on left, anchor at bar center (T-junction)
    { cells: [{ x: 0, y: 1 }, { x: 0, y: 0 }, { x: 1, y: 1 }, { x: 0, y: 2 }], width: 2, height: 3 },
    // 180° - bar on bottom, anchor at bar center (T-junction)
    { cells: [{ x: 1, y: 1 }, { x: 1, y: 0 }, { x: 0, y: 1 }, { x: 2, y: 1 }], width: 3, height: 2 },
    // 270° - bar on right, anchor at bar center (T-junction)
    { cells: [{ x: 1, y: 1 }, { x: 1, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 2 }], width: 2, height: 3 },
];
export const PIECE_DEFINITIONS = {
    I: I_ROTATIONS,
    L: L_ROTATIONS,
    O: O_ROTATIONS,
    S: S_ROTATIONS,
    T: T_ROTATIONS,
};
/**
 * Get the shape of a piece with current rotation and mirroring applied
 */
export function getShapeForPiece(piece) {
    const rotations = PIECE_DEFINITIONS[piece.type];
    const shape = rotations[piece.currentRotation % rotations.length];
    if (!piece.mirrored) {
        return shape;
    }
    // Mirror horizontally
    const mirroredCells = shape.cells.map((cell) => ({
        x: shape.width - 1 - cell.x,
        y: cell.y,
    }));
    return {
        cells: mirroredCells,
        width: shape.width,
        height: shape.height,
    };
}
/**
 * Get all cells occupied by a placed piece in grid coordinates
 */
export function getPieceCells(piece) {
    const shape = getShapeForPiece(piece);
    return shape.cells.map((cell) => ({
        x: piece.gridX + cell.x,
        y: piece.gridY + cell.y,
    }));
}
//# sourceMappingURL=tetromino.js.map